import React from 'react';

import './Card.scss';

export type CardProps = {
    filled?: boolean;
    row?: boolean;
    bordered?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Card: React.FC<CardProps> = ({ children, filled, row, className, bordered, ...props }) => {
    return (
        <div data-filled={filled} data-row={row} data-bordered={bordered !== false} className={`card ${className ?? ''}`} {...props}>
            {children}
        </div>
    );
};
